export default __webpack_public_path__ + "static/media/heavy-bleeding-ON.21089e40.png";